import { render, staticRenderFns } from "./OtherEditTable.vue?vue&type=template&id=1a3a2e8d&"
import script from "./OtherEditTable.vue?vue&type=script&lang=js&"
export * from "./OtherEditTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports